import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { getLogs } from '../api'
import './OperationsLog.css'

const ACTION_LABELS: Record<string, string> = {
  manual_control_start: '🕹️ תחילת שליטה ידנית',
  manual_control_stop:  '⏹️ סיום שליטה ידנית',
  command_sent:         '📡 פקודה נשלחה',
  mission_started:      '🚀 משימה הופעלה',
  mission_paused:       '⏸️ משימה הושהתה',
  mission_resumed:      '▶️ משימה חודשה',
  mission_completed:    '✅ משימה הושלמה',
  comm_test:            '📶 בדיקת תקשורת',
  takeoff:              '🛫 המראה',
  land:                 '🛬 נחיתה',
  rtl:                  '🏠 חזרה הביתה',
  goto:                 '📍 עבור לכאן',
}

export default function OperationsLog() {
  const [filterDrone, setFilterDrone] = useState('')
  const [filterAction, setFilterAction] = useState('')

  const { data: logs = [], isLoading } = useQuery({
    queryKey: ['logs', filterDrone, filterAction],
    queryFn: () => getLogs({
      ...(filterDrone  ? { drone_id:    filterDrone  } : {}),
      ...(filterAction ? { action_type: filterAction } : {}),
    }),
    refetchInterval: 10000,
  })

  const formatDate = (s: string) => {
    if (!s) return '—'
    const d = new Date(s)
    return d.toLocaleDateString('he-IL') + ' ' + d.toLocaleTimeString('he-IL')
  }

  return (
    <div className="oplog-page">
      <div className="oplog-header">
        <h1 className="oplog-title">📋 לוג פעולות תפעולי</h1>
        <div className="oplog-filters">
          <input
            className="oplog-input"
            placeholder="🔍 חיפוש לפי ID רחפן"
            value={filterDrone}
            onChange={e => setFilterDrone(e.target.value)}
          />
          <select
            className="oplog-select"
            value={filterAction}
            onChange={e => setFilterAction(e.target.value)}
          >
            <option value="">כל הפעולות</option>
            {Object.entries(ACTION_LABELS).map(([k, v]) => (
              <option key={k} value={k}>{v}</option>
            ))}
          </select>
          <button className="oplog-clear" onClick={() => { setFilterDrone(''); setFilterAction('') }}>
            ✕ נקה
          </button>
        </div>
      </div>

      {isLoading ? (
        <div className="oplog-loading">טוען לוגים...</div>
      ) : logs.length === 0 ? (
        <div className="oplog-empty">אין לוגים מתאימים</div>
      ) : (
        <div className="oplog-table-wrap">
          <table className="oplog-table">
            <thead>
              <tr>
                <th>תאריך ושעה</th>
                <th>פעולה</th>
                <th>רחפן</th>
                <th>מצב שליטה</th>
                <th>תוצאה</th>
                <th>הערות</th>
              </tr>
            </thead>
            <tbody>
              {logs.map((log: any) => (
                <tr key={log.id}>
                  <td className="oplog-time" dir="ltr">{formatDate(log.created_at)}</td>
                  <td>
                    <span className="oplog-action-badge">
                      {ACTION_LABELS[log.action_type] ?? log.action_type}
                    </span>
                  </td>
                  <td className="oplog-drone">{log.drone_id ? log.drone_id.slice(0, 8) + '…' : '—'}</td>
                  <td>{log.control_mode ?? '—'}</td>
                  <td>
                    {log.result && (
                      <span className={`oplog-result oplog-result-${log.result}`}>
                        {log.result === 'success' ? '✅' : log.result === 'failed' ? '❌' : '⏳'} {log.result}
                      </span>
                    )}
                  </td>
                  <td className="oplog-notes">{log.notes ?? '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}
